import React from "react";
import Slider from "react-slick";

import theme from "../../../foundation/Theme";

import {
  CardWrapper,
  Description,
  Quotes,
  SliderWrapper,
  TestimonialContainer,
  Wrapper,
  Name,
  QuotesWrapper,
  AvatarContainer,
  Avatar,
} from "./style";
import SectionHeading from "../SectionHeading";

function Testimonials(props) {
  const {
    removeFixBtn,
    data = [],
    headingColor = theme.colorsV2.blue.shade_700,
    mobilePadding = "8px",
    arrowImage = "arrow-new-blue.svg",
    className,
  } = props || {};
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    swipeToSlide: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 2.5,
          dots: false,
          infinite: false,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.25,
          dots: false,
          infinite: false,
          slidesToScroll: 1,
          arrows: true,
        },
      },
    ],
  };
  return (
    <Wrapper ref={removeFixBtn} className={className}>
      <TestimonialContainer>
        <SectionHeading
          title={data.title ? data.title : "What our members are saying"}
          color={headingColor}
          variant="heading5"
          mb={"2px"}
          isTestimonial
          mobilePadding={mobilePadding}
          disableSeparator
        />
        <SliderWrapper maxWidth={"100%"} arrowImage={arrowImage}>
          <Slider {...settings}>
            {(data?.testimonials || data).map((data, index) => {
              return (
                <CardWrapper bg={theme.colors.white} key={index}>
                  {data?.image && (
                    <AvatarContainer>
                      <Avatar src={data?.image} />
                      <Name variant="label2">{data?.userName}</Name>
                    </AvatarContainer>
                  )}
                  <QuotesWrapper
                    mt={[data?.image ? "48px" : "20px", "48px", "48px"]}
                    mb={["20px", "48px", "48px"]}
                  >
                    <Quotes icon={"icon-quotes"} height="16px" width="25px" />
                    <Quotes
                      icon={"icon-quotes"}
                      height="16px"
                      width="25px"
                      invert={"true"}
                    />
                    <Description variant={"paragraph2"}>
                      {data?.comment}
                    </Description>
                  </QuotesWrapper>
                  {!data?.image && (
                    <Name variant="label2">{data?.userName}</Name>
                  )}
                </CardWrapper>
              );
            })}
          </Slider>
        </SliderWrapper>
      </TestimonialContainer>
    </Wrapper>
  );
}

export default Testimonials;
